import './App.css';
import PaintedAreaCalculator from './PaintedAreaCalculator';

function App() {
  return (
    <div className="w-full md:w-96 md:max-w-full bg-gray-100 md:rounded-xl md:mt-0 mx-auto">
      <div className="p-6  sm:rounded-md8">
      <h1 className="mb-4 text-2xl font-medium text-center">
        Painted Area Calculator
      </h1>
      <PaintedAreaCalculator />
      </div>  
    </div>
  );
}

export default App;
